import gql from "graphql-tag";
import AmericanCompanyIssuerTopLevel from "lib/fragments/AmericanCompanyIssuerTopLevel";
import BrazilianCompanyIssuerTopLevel from "lib/fragments/BrazilianCompanyIssuerTopLevel";
import BrazilianRealEstateFundTopLevel from "lib/fragments/BrazilianRealEstateFundTopLevel";

export default gql`
  query IssuerByTickerSymbol($tickerSymbol: TickerSymbol!, $country: SecurityCountry!) {
    issuerByTickerSymbol(tickerSymbol: $tickerSymbol, country: $country) {
      ... on AmericanCompanyIssuer {
        ...AmericanCompanyIssuerTopLevel
      }
      ... on BrazilianCompanyIssuer {
        ...BrazilianCompanyIssuerTopLevel
      }
      ... on BrazilianRealEstateFund {
        ...BrazilianRealEstateFundTopLevel
      }
    }
  }

  ${AmericanCompanyIssuerTopLevel}
  ${BrazilianCompanyIssuerTopLevel}
  ${BrazilianRealEstateFundTopLevel}
`;
